import {Row} from "@tanstack/react-table";
import {FiChevronDown, FiChevronRight} from "react-icons/fi";

import {IconButton} from "@/components/iconButton/IconButton.tsx";

export const TableRowExpander = <T,>({row}: {row: Row<T>}) => {
  return (
    <IconButton
      size="fitIcon"
      variant="ghost"
      icon={row.getIsExpanded() ? () => <FiChevronDown size="1.3rem" /> : () => <FiChevronRight size="1.3rem" />}
      onClick={row.getToggleExpandedHandler()}
    />
  );
};
